<ng-container *ngIf="{ showToolTip: showToolTip$ | async } as vm">
  <div (click)="hideUserList()" role="button" class="small-text mt-2">
    <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back To Chatroom
  </div>
  <ng-container *ngFor="let user of this.chatroomUsers$ | async">
    <div class="mt-2">
      <img
        class="img-presence"
        src="assets/images/presence/{{ user.presenceLogo }}"
        title="{{ user.presenceDesc }}"
      />
      <span
        class="ml-2"
        innerHTML="{{ user.first }} {{ user.last }}"
        (click)="
          vm.showToolTip &&
            user.userId !== currentUserId &&
            confirmPersonalTooltip(user.userId)
        "
        [ngClass]="{
          'cursor-pointer': vm.showToolTip && user.userId !== currentUserId
        }"
        autoClose="true"
        triggers="none"
        container="body"
        placement="right auto"
      ></span>
    </div>
  </ng-container>
</ng-container>
